// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:GLOBAL:NAV
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/moment.min.js': 'moment',
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, Backbone, $, moment, _) {

  "use strict";

  var M = m_module.M;
  M.View = M.View || {};
  M.View.Util = M.View.Util || {};

  /**
   * @class M.View.Util.StickyNavHeader
   *
   */
  M.View.Util.StickyNavHeader = Backbone.View.extend({
    className: 'stickyNavHeader',

    initialize: function() {
      var that = this;

      M.required(this.options.$stickyElement);
      this.$stickyElement = this.options.$stickyElement;
      // sticky header is not shown when the page loads
      this.isStickyHeaderShown = false;

      /* clone the original element and use it as a placeholder
        when the original element is appended to the sticky header
        clone(false, false) clones DOM elements without event handlers */
      this.$placeHolder = this.$stickyElement.clone(false, false).
        addClass('stickyElementPlaceHolder');

      this.stickyElOriginalPosition = this.$stickyElement.offset().top;

      this.$el = $(this.el);
      this.$stickyElement.after(this.$el);

      $(window).scroll(function() {
        that.showHideStickyHeader();
      });
    },

    render: function() {
      return this;
    },

    /**
      * The function first polls to see if window had scrolled past the
      * sticky element. Then, it uses the current position if window has
      * scrolled past the sticky element now.
      * If there's change in the state, either:
      *   1. append the sticky element to the header and put if the clone
      *   2. Remove the clone and put back the sticky element
      */
    showHideStickyHeader: function() {

      var scrolledPastStickyElementInitial
        = this.scrolledPastStickyElement || false;

      this._updateStickyElPosition();

      this.scrolledPastStickyElement
        = ($(window).scrollTop() >= this.stickyElOriginalPosition);


      // move elements only if there's change in the state to minimize actions
      if (!scrolledPastStickyElementInitial
         && this.scrolledPastStickyElement) {
        this.$el.before(this.$placeHolder);
        this.$el.append(this.$stickyElement);
        this.$el.show();
        this.isStickyHeaderShown = true;
      }
      else if (scrolledPastStickyElementInitial
         && !this.scrolledPastStickyElement) {
        this.$placeHolder.remove();
        this.$el.before(this.$stickyElement);
        this.$el.hide();
        this.isStickyHeaderShown = false;
      }
    },

    // Leave this as a function because we might have better ways to
    // detect if the sticky element is shown or not
    _isStickyElementShown: function() {
      return this.isStickyHeaderShown;
    },

    // When the sticky element is now shown, it should update where
    // the original header is, because show/hide the activity feed
    // will move the header position down and up.
    _updateStickyElPosition: function() {
      if (!this._isStickyElementShown()) {
        this.stickyElOriginalPosition = this.$stickyElement.offset().top;
      }
    }

  });

  return {
  };

});
